module.exports = __webpack_public_path__ + "static/media/sendra-martorell.36484533.jpg";